import { useContext } from 'react';
import SinglePortfolioContext, { SinglePortfolioType } from './context';

/**
 * Custom hook to access the SinglePortfolio context.
 * Provides type safety and ensures the hook is used within the correct provider.
 */
const useSinglePortfolio = (): SinglePortfolioType => {
    const context = useContext(SinglePortfolioContext);

    if (context === undefined) {
        throw new Error('useSinglePortfolio can only be used inside SinglePortfolioProvider');
    }

    return context;
};

export default useSinglePortfolio;
